import './Contact.scss'
import React from 'react'
import Button from '../Button/Button'

function Contact() {
    return (
        <section
            id="contact"
            className="contact"
            aria-labelledby="contact-title"
        >
            <div className="contact__container">
                <h2 id="contact-title" className="contact__title">
                    Vous avez un projet web ?
                </h2>

                <p className="contact__text">
                    Vous voulez clarifier vos choix techniques avant de vous
                    lancer, faire évoluer un site existant, connecter vos
                    outils entre eux ou relier votre site à un ERP ?
                </p>

                <p className="contact__text">
                    Envoyez-moi quelques lignes sur votre contexte, vos
                    objectifs et vos délais.
                </p>

                <div className="contact__actions">
                    <Button
                        type="link"
                        variant="darkButton"
                        href="mailto:contact@benjamingibert.com?subject=Demande%20de%20contact"
                        ariaLabel="Envoyer un email à Benjamin Gibert"
                    >
                        Me contacter
                    </Button>

                    <Button
                        type="link"
                        variant="lightButton"
                        href="https://www.malt.fr/profile/benjamingibert"
                        target="_blank"
                        rel="noopener noreferrer"
                        ariaLabel="Voir le profil Malt de Benjamin Gibert, s’ouvre dans un nouvel onglet"
                    >
                        Voir mon profil Malt
                    </Button>
                </div>
            </div>
        </section>
    )
}

export default Contact